module.exports = __webpack_public_path__ + "img/sample-report-13@3x.e61d64f9.png";